import styled from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { bodyStyle } from "../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { theme } from "../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../common-deprecated/themes/common";

export const Title = styled.h2`
    ${bodyStyle};
    text-transform: none;
`;

export const Card = styled.div<SpaceProps>`
    margin: ${theme.space[3]}px 0;
    margin-bottom: ${theme.space[5]}px;
    border: 1px solid ${theme.colors.grey2};
    ${space}
`;

export const CardHeader = styled.header`
    padding: ${theme.space[2]}px;
    border-bottom: 1px solid ${theme.colors.grey2};
`;

export const CardTitle = styled.div<SpaceProps>`
    font-family: ${theme.fonts.regular};
    ${space}
`;

export const CardAddress = styled.div`
    color: ${theme.colors.grey7};
    white-space: pre-wrap;
`;

export const CardBody = styled.div<SpaceProps>`
    padding: ${theme.space[3]}px ${theme.space[2]}px ${theme.space[1]}px;
    @media ${getBreakpoint("up", "md")} {
        padding: ${theme.space[3]}px ${theme.space[2]}px;
    }
    ${space}
`;

export const CardImage = styled.div<SpaceProps>`
    display: flex;
    justify-content: center;
    padding: ${theme.space[3]}px ${theme.space[5]}px 0;
`;

export const List = styled.dl`
    @media ${getBreakpoint("up", "md")}, print {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        width: 100%;
        gap: ${theme.space[3] / 2}px;
    }

    dt,
    dd {
        font-weight: 400;
        color: ${theme.colors.primaryBlack};
    }

    dd {
        padding-bottom: ${theme.space[2]}px;
        word-wrap: break-word;
        @media ${getBreakpoint("up", "md")}, print {
            padding-bottom: 0;
            text-align: end;
        }
    }
`;
